import { render } from "./DeleteAccountModal.vue?vue&type=template&id=b19eff36&ts=true"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__